import LegalPageLayout from './LegalPageLayout';
import { COMPANY_INFO } from '../constants/companyInfo';

export default function TermsOfUsePage() {
  return (
    <LegalPageLayout title="Kullanım Koşulları">
      <p>
        Bu kullanım koşulları, <strong>{COMPANY_INFO.name}</strong> tarafından sunulan web sitesi ve ilgili dijital
        hizmetlerin kullanımına ilişkin şartları belirler. Siteyi ziyaret eden veya hizmetlerden faydalanan her kullanıcı,
        aşağıdaki koşulları kabul etmiş sayılır.
      </p>

      <h2>1. Hizmetin Kapsamı</h2>
      <p>
        {COMPANY_INFO.name}; gayrimenkul tanıtımı, içerik üretimi, pazarlama destek süreçleri ve buna bağlı dijital araçlar
        sağlayabilir. Hizmet kapsamı, teknik ihtiyaçlar ve ürün geliştirmeleri doğrultusunda güncellenebilir.
      </p>

      <h2>2. Kullanıcı Sorumlulukları</h2>
      <ul>
        <li>Paylaşılan bilgilerin doğru, güncel ve hukuka uygun olmasından kullanıcı sorumludur.</li>
        <li>Hesap bilgileri ve erişim şifreleri gizli tutulmalıdır.</li>
        <li>Hizmet, üçüncü kişilere zarar verecek veya mevzuata aykırı biçimde kullanılamaz.</li>
      </ul>

      <h2>3. Yasaklı Kullanımlar</h2>
      <ul>
        <li>Sisteme izinsiz erişim denemeleri yapmak, güvenlik önlemlerini aşmaya çalışmak.</li>
        <li>Telif, marka veya kişilik haklarını ihlal eden içerik yüklemek veya üretmek.</li>
        <li>Hizmeti spam, dolandırıcılık veya yanıltıcı amaçlarla kullanmak.</li>
      </ul>

      <h2>4. Fikri Mülkiyet Hakları</h2>
      <p>
        Site tasarımı, yazılım bileşenleri, marka unsurları ve içerik altyapısı üzerindeki haklar {COMPANY_INFO.name}’e veya
        lisans verenlerine aittir. Kullanıcıya yalnızca hizmetten yararlanma amacıyla sınırlı, devredilemez bir kullanım hakkı
        tanınır.
      </p>

      <h2>5. Ücretlendirme ve Ödeme</h2>
      <p>
        Ücretli hizmetler, ilgili paket ve kampanya koşullarına tabidir. Fiyat, dönem, kapsam ve kampanya şartları gerektiğinde
        güncellenebilir. Güncel ücretlendirme bilgileri platformda duyurulur.
      </p>

      <h2>6. Hizmet Sürekliliği ve Değişiklik</h2>
      <p>
        Hizmet kalitesini artırmak veya güvenliği sağlamak amacıyla bakım, güncelleme ve altyapı değişiklikleri yapılabilir.
        Gerekli görülen durumlarda hizmetin bir kısmı geçici olarak durdurulabilir.
      </p>

      <h2>7. Sorumluluğun Sınırlandırılması</h2>
      <p>
        {COMPANY_INFO.name}, hizmetin kesintisiz veya hatasız çalışacağını garanti etmez. Yasal sınırlar içinde olmak kaydıyla,
        dolaylı zararlar, gelir kaybı ve veri kayıplarından sorumluluk kabul edilmez.
      </p>

      <h2>8. Fesih</h2>
      <p>
        Kullanım koşullarına aykırı davranış tespit edilmesi halinde kullanıcı erişimi askıya alınabilir veya sonlandırılabilir.
      </p>

      <h2>9. Yürürlük</h2>
      <p>
        Bu koşullar yayım tarihinde yürürlüğe girer. {COMPANY_INFO.name}, gerekli gördüğünde metni güncelleme hakkını saklı tutar.
      </p>
    </LegalPageLayout>
  );
}
